<div class="relative w-full rounded-lg mb-0.5 hover:opacity-75 transition-all">
  <!-- Thumbnail -->
  <img
    [src]="message.mediaUrl"
    class="w-full h-auto rounded cursor-pointer message-image"
    alt="Image message"
    (click)="openPreview()"
  />

  @if (!message.text && message.creationDate) {
    <div class="msg-time-overlay">{{ message.creationDate | date: messageDateFormat }}</div>
  }

  <p *ngIf="message.text" class="p-2 leading-6">
    {{ message.text }}
  </p>
</div>

<!-- Fullscreen Preview Overlay -->
<div *ngIf="previewVisible" class="preview-overlay" (click)="closeOnBackdrop($event)">
  <img
    [src]="message.mediaUrl"
    class="preview-image"
    [style.transform]="'scale(' + scale + ')'"
    (click)="$event.stopPropagation()"
  />

  <div class="preview-toolbar" (click)="$event.stopPropagation()">
    <button class="tool-btn" (click)="zoomOut()" title="Zoom out">
      <i class="fa-light fa-magnifying-glass-minus"></i>
    </button>
    <button class="tool-btn" (click)="reset()" title="Reset size">
      <i class="fa-light fa-expand"></i>
    </button>
    <button class="tool-btn" (click)="zoomIn()" title="Zoom in">
      <i class="fa-light fa-magnifying-glass-plus"></i>
    </button>
    <button class="tool-btn close-btn" (click)="previewVisible = false" title="Close">
      <i class="fa-light fa-xmark"></i>
    </button>
  </div>
</div>
